export const VALIDATION = {
  REQUIRED: "Required",
  REQUIRED_AT_LEAST_ONE: "At least one selection required",
  REQUIRED_FILE: "File selection required",
}
